import * as React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormInput } from '@enginuity-apps-ui-components/molecules/form-elements/form-input/form-input';
import EditableFormSection from '../../../../../ui-components/library/apps/organisms/editable-section/editable-form-section';
import { IUserProfileFormData } from '@enginuity-common/types/user';
import { ISubmitStatus } from '../../pages/account/manage-account';
import { useEffect } from 'react';

export type IManageAccountSetupProps = {
  onSubmit: (data: IUserProfileFormData) => Promise<ISubmitStatus>;
  data?: IUserProfileFormData;
  intialEditMode?: boolean;
};

export default function ManageAccountSetup({ onSubmit, data, intialEditMode }: IManageAccountSetupProps) {
  const { register, handleSubmit, errors } = useForm();
  const [editMode, setEditMode] = useState<boolean>(!!intialEditMode)
  const [submitError, setSubmitError] = useState<JSX.Element | undefined>();
  const [formData, setFormData] = useState<IUserProfileFormData | undefined>(data);

  const saveForm = (submitData: IUserProfileFormData) => {
    onSubmit(submitData)
      .then((submitStatus: ISubmitStatus) => {
        if (submitStatus.result) {
          setEditMode(false);
        }
        else {
          setSubmitError(submitStatus.error);
        }
      })
  }

  const resetData = (mode: boolean) => {
    setFormData(data && { ...data }); //revert to original data
    setEditMode(mode);
  }

  useEffect(() => {
    setFormData(data);
  }, [data]);

  return (
    <EditableFormSection
      sectionTitle="01. Account setup"
      onSubmit={handleSubmit(saveForm)}
      submitError={submitError}
      errors={errors}
      editMode={editMode}
      onEditModeChange={(mode: boolean) => resetData(mode)}
    >
      <div className="row md-spacer-32 spacer-16">
        <div className="col-lg-5 col-xl-4">
          <FormInput
            label={<>First Name {editMode && "*"}</>}
            id="firstName"
            defaultValue={formData && formData.firstName}
            ref={register({
              required: "Please enter your first name.", maxLength: {
                value: 50, message: 'Last name cannot be more than 50 characters'
              }
            })}
            errors={errors}
            showReadOnly={!editMode}
          />
        </div>
        <div className="col-lg-5 col-xl-4  lg-no-spacer spacer-16">
          <FormInput
            label={<>Last Name {editMode && "*"}</>}
            id="lastName"
            defaultValue={formData && formData.lastName}
            ref={register({
              required: "Please enter your last name.", maxLength: {
                value: 50, message: 'Last name cannot be more than 50 characters'
              }
            })}
            errors={errors}
            showReadOnly={!editMode}
          />
        </div>
      </div>
      <div className="row spacer-16">
        <div className="col-lg-5 col-xl-4">
          <FormInput
            label={<>Email {editMode && "*"}</>}
            id="email"
            defaultValue={formData && formData.email}
            ref={register({
              required: "Please enter your email for the account.", minLength: {
                value: 5, message: 'Email length cannot be less than 5 characters'
              }, maxLength: {
                value: 100, message: 'Email length cannot be more than 100 characters'
              },
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Please enter a valid email address"
              }
            })}
            errors={errors}
            showReadOnly={!editMode}
          />
        </div>
      </div>
      <div className="row spacer-16">
        <div className="col-lg-12">
          <p className="required-field-text color-purple-grey">{editMode ? <>* indicates required field</> : <>&nbsp;</>}</p>
        </div>
      </div>
    </EditableFormSection>
  );
}
